import React, {useRef} from 'react';
import {Button, Image, Modal} from 'react-bootstrap';
import ApiService from "../api/ApiService";
import QRCode from "qrcode";
import {toast} from "react-toastify";
import LocalDataService from "../api/LocalDataService";
import {isVisible} from "bootstrap/js/src/util";

const wechatIcon = '/images/vip/vip_pay_method_wechat.svg'
const alipayIcon = '/images/vip/vip_pay_method_alipay.svg'
const PayModal = ({visible, product, payMethod, onClose}) => {

    const [isMobile, setIsMobile] = React.useState(false);
    const [selectedPaymentMethod, setSelectedPaymentMethod] = React.useState('wechat');
    const [qrCodeUrl, setQrCodeUrl] = React.useState('');
    const [codeUrl, setCodeUrl] = React.useState(''); // 添加codeUrl状态
    const [orderId, setOrderId] = React.useState(''); // 保存订单ID
    const api = new ApiService();

    const timerId = useRef(null);
    const clearTimerId = useRef(null);
    const appid = "wxbf26c332449b8eb9";

    React.useEffect(() => {
        if (!visible) return;
        
        // 获取当前是否为移动端
        const checkIsMobile = () => {
            return window.innerWidth < 768;
        };
        
        // 设置初始值
        setIsMobile(checkIsMobile());

        const handleResize = () => {
            setIsMobile(checkIsMobile());
        };

        if (product!= null){
            if (payMethod != null) {
                creatQRCode(payMethod, product,checkIsMobile);
            } else {
                creatQRCode(selectedPaymentMethod, product,checkIsMobile);
            }
        }

        window.addEventListener('resize', handleResize);

        return () => {
            // 清除定时器
            if (timerId.current) {
                clearInterval(timerId.current);
            }
            if (clearTimerId.current) {
                clearTimeout(clearTimerId.current);
            }
            window.removeEventListener('resize', handleResize);
        };
    }, [visible,product, payMethod, selectedPaymentMethod]);

    
    // 在移动端直接唤起支付应用
    const openAppOnMobile = (payType, codeUrl) => {
        if (!isMobile) return;
        
        if (payType === 'wechat') {
            // 微信支付链接处理
            const wechatUrl = codeUrl.startsWith('weixin://') ? codeUrl : `weixin://wap/pay?prepayid=${codeUrl}`;
            window.location.href = wechatUrl;
        } else if (payType === 'alipay') {
            // 支付宝支付链接处理
            const alipayUrl = codeUrl.startsWith('alipays://') ? codeUrl : `alipays://platformapi/startapp?saId=10000007&qrcode=${encodeURIComponent(codeUrl)}`;
            window.location.href = alipayUrl;
        }
    };

    const creatQRCode = (payType, product,isMobile) => {
        const realPayType = payType === 'wechat' ? 'wx_native' : 'alipay_h5';
        // 清除定时器
        if (timerId.current) {
            clearInterval(timerId.current);
        }
        if (clearTimerId.current) {
            clearTimeout(clearTimerId.current);
        }
        api.createOrder(product.id, null, null, null, 1, realPayType,appid).then(res => {
            if (res.code === 200) {
                // 使用 qrcode 库生成二维码数据
                const codeUrl = payType === 'wechat' ? res.data.wx.code_url : res.data.alipay;
                setCodeUrl(codeUrl); // 保存原始codeUrl
                setOrderId(res.data.orderNo); // 保存订单ID
                
                // 如果是移动端，则尝试直接打开App
                if (isMobile&&payType !== 'wechat') {
                    openAppOnMobile(payType, codeUrl);
                }
                
                QRCode.toDataURL(codeUrl, (err, url) => {
                    if (err) {
                        console.error(err);
                        return;
                    }
                    setQrCodeUrl(url);
                    timerId.current = setInterval(() => {
                        get_order_info(res.data.orderNo);
                    }, 1500); // 增加到1.5秒一次轮询，减少服务器压力
                    clearTimerId.current = setTimeout(() => {
                        clearInterval(timerId.current);
                    }, 5 * 60 * 1000);
                });
            }else {
                toast.error(res.msg);
            }
        });
    };

    const get_order_info = async (orderId) => {
        let api = new ApiService();
        let res = await api.orderInfo(orderId);

        if (res.data.status == 1) {
            toast('支付成功')
            clearInterval(timerId.current);
            const user = await api.get_user_info();
            console.log('Logged in user:', user);
            //更新用户信息
            LocalDataService.set_user_data(user.data);
            // 触发用户状态更新事件
            window.dispatchEvent(new Event('userLoginStatusChanged'));
            onClose();
        }

    }
    return (

        <Modal show={visible} centered onHide={onClose}
               style={{'--bs-modal-margin': '2rem',}}>
            <Modal.Header closeButton style={{
                background: 'linear-gradient(90deg,#02C8E3 30%, #963BC8 120%)',
                borderBottomColor: 'transparent'
            }}>
                <span style={{
                    color: '#060606',
                    fontSize: '22px'
                }}>{payMethod == null ? product?.title : (payMethod === 'wechat' ? '微信支付' : '支付宝支付')}</span>
            </Modal.Header>
            <Modal.Body style={{background: '#1E2129'}}>
                {payMethod == null ? (<div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        color: '#B4BFC5',
                        fontSize: '16px',
                        padding: '20px'
                    }}>
                        <p style={{alignSelf: "start"}}>套餐价格：<span
                            style={{color: '#E98E48', fontSize: '22px'}}>￥{product?.price / 100}</span><span
                            style={{textDecoration: 'line-through'}}>￥{product?.originPrice / 100}</span></p>
                        <p>个人中心查看权益对比</p>
                    </div>) :
                    (
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'start',
                            color: '#B4BFC5',
                            fontSize: '16px',
                            padding: '20px'
                        }}>
                            <p style={{alignSelf: "start"}}>支付金额：</p>
                            <div style={{color: '#E98E48', fontSize: '22px'}}>￥{product?.price / 100}</div>
                        </div>
                    )
                }


                <span style={{
                    color: '#fff',
                    fontSize: '16px',
                    borderLeftWidth: '5px',
                    borderLeftStyle: 'solid',
                    borderLeftColor: '#2E9FDC',
                    padding: '0px 10px',
                }}>支付</span>
                <div className={'mt-2'} style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                    {isMobile&&(payMethod || selectedPaymentMethod) !== 'wechat' ? (
                        <div style={{ 
                            display: 'flex', 
                            flexDirection: 'column', 
                            alignItems: 'center',
                            padding: '20px',
                            color: 'white'
                        }}>
                            <p>正在唤起支付应用...</p>
                            <p>如果没有自动跳转，请点击下方按钮手动打开</p>
                            <Button 
                                variant="primary" 
                                onClick={() => openAppOnMobile(payMethod || selectedPaymentMethod, codeUrl)}
                                style={{ marginTop: '10px' }}
                            >
                                打开{(payMethod || selectedPaymentMethod) === 'wechat' ? '微信' : '支付宝'}
                            </Button>
                            <Button 
                                variant="outline-light" 
                                onClick={() => get_order_info(orderId)}
                                style={{ marginTop: '10px' }}
                            >
                                已完成支付，检查支付结果
                            </Button>
                        </div>
                    ) : (
                        <Image src={qrCodeUrl}
                               style={{width: '240px', height: '240px', marginBottom: '20px', alignSelf: 'center'}}/>
                    )}
                </div>
                {payMethod == null &&
                    <div className={'d-flex justify-content-center flex-md-row flex-column'}>
                        <Button
                            className={` mb-2 payment-method-button ${selectedPaymentMethod === 'wechat' ? 'selected-payment-method-button' : ''}`}
                            onClick={() => setSelectedPaymentMethod('wechat')}>
                            <img src={wechatIcon} alt="微信支付" className="payment-method-icon"/>
                            微信支付
                        </Button>

                        <Button
                            className={` mb-2 payment-method-button ${selectedPaymentMethod === 'alipay' ? 'selected-payment-method-button' : ''}`}
                            onClick={() => setSelectedPaymentMethod('alipay')}>
                            <img src={alipayIcon} alt="支付宝支付" className="payment-method-icon"/>
                            支付宝支付
                        </Button>
                    </div>
                }

                <p className="text-center text-white">
                    打开{payMethod === null ? (selectedPaymentMethod === 'wechat' ? '微信' : '支付宝') : (payMethod === 'wechat' ? '微信' : '支付宝')}支付扫描二维码完成支付
                </p>
            </Modal.Body>
        </Modal>

    );
};

export default PayModal;